import { __makeTemplateObject, __assign, __rest } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { Box, themeGet } from '@primer/react';
import styled from 'styled-components';
import { isEnterOrSpacePressed } from '../../utils/functions.js';
import LTCheckbox from '../LTCheckbox/index.js';
import LTTooltip from '../LTTooltip/index.js';
import LTText from '../LTText/index.js';
import LTTagGroup from '../LTTagGroup/index.js';

var Card = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-bottom: 1px solid;\n  border-color: ", ";\n  display: flex;\n  gap: 24px;\n  justify-content: space-between;\n  padding: 8px 16px;\n  &:last-child {\n   border-bottom: none;\n  }\n  &:hover {\n    background-color: #f7f7f7;\n  }\n\n  @media only screen and (max-width: 320px) {\n    flex-direction: column;\n    gap: 0px;\n  }\n"], ["\n  border-bottom: 1px solid;\n  border-color: ", ";\n  display: flex;\n  gap: 24px;\n  justify-content: space-between;\n  padding: 8px 16px;\n  &:last-child {\n   border-bottom: none;\n  }\n  &:hover {\n    background-color: #f7f7f7;\n  }\n\n  @media only screen and (max-width: 320px) {\n    flex-direction: column;\n    gap: 0px;\n  }\n"])), themeGet("colors.border.default"));
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex-direction: column;\n  display: flex;\n  gap: 8px;\n  overflow: hidden;\n  padding: 8px 0px;\n"], ["\n  flex-direction: column;\n  display: flex;\n  gap: 8px;\n  overflow: hidden;\n  padding: 8px 0px;\n"])));
var SecondaryElements = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  gap: 24px;\n"], ["\n  align-items: center;\n  display: flex;\n  gap: 24px;\n"])));
var ActionLink = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  cursor: pointer;\n  &:hover {\n    & > span {\n      text-decoration: underline;\n    }\n  }\n  &:focus-visible {\n    outline: 2px solid;\n    outline-color: ", ";\n    outline-offset: -2px;\n  }\n"], ["\n  cursor: pointer;\n  &:hover {\n    & > span {\n      text-decoration: underline;\n    }\n  }\n  &:focus-visible {\n    outline: 2px solid;\n    outline-color: ", ";\n    outline-offset: -2px;\n  }\n"])), themeGet("colors.focus.outlineColor"));
var Unit = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  gap: 4px;\n  overflow: hidden;\n"], ["\n  align-items: center;\n  display: flex;\n  gap: 4px;\n  overflow: hidden;\n"])));
var OtherInfo = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  overflow: hidden;\n  margin-left: 24px;\n  @media only screen and (max-width: 1024px) {\n    flex-wrap: wrap;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  overflow: hidden;\n  margin-left: 24px;\n  @media only screen and (max-width: 1024px) {\n    flex-wrap: wrap;\n  }\n"])));
var Dot = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 50%;\n  height: 2px;\n  min-width: 2px;\n  width: 2px;\n"], ["\n  background-color: ", ";\n  border-radius: 50%;\n  height: 2px;\n  min-width: 2px;\n  width: 2px;\n"])), themeGet("colors.fg.disabled"));
var Heading = function Heading(_a) {
  var ariaLabelForCheckbox = _a.ariaLabelForCheckbox,
    elementType = _a.elementType,
    icon = _a.icon;
    _a.isLink;
    var isCheckboxChecked = _a.isCheckboxChecked,
    showCheckbox = _a.showCheckbox,
    _onChange = _a.onChange,
    onClick = _a.onClick,
    title = _a.title,
    tooltip = _a.tooltip,
    props = __rest(_a, ["ariaLabelForCheckbox", "elementType", "icon", "isLink", "isCheckboxChecked", "showCheckbox", "onChange", "onClick", "title", "tooltip"]);
  var Title = elementType ? styled(elementType)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      cursor: pointer;\n      &:hover {\n        & > span {\n          text-decoration: underline;\n        }\n      }\n      &:focus-visible {\n        outline: 2px solid;\n        outline-color: ", ";\n        outline-offset: -2px;\n      }\n    "], ["\n      cursor: pointer;\n      &:hover {\n        & > span {\n          text-decoration: underline;\n        }\n      }\n      &:focus-visible {\n        outline: 2px solid;\n        outline-color: ", ";\n        outline-offset: -2px;\n      }\n    "])), themeGet("colors.focus.outlineColor")) : ActionLink;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: "8px",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    },
    id: "lt-card-title"
  }, showCheckbox ? /*#__PURE__*/React.createElement(LTCheckbox, {
    ariaLabel: ariaLabelForCheckbox,
    checked: isCheckboxChecked,
    onChange: function onChange(value) {
      _onChange(value);
    },
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onKeyDown: function onKeyDown(e) {
      return e.stopPropagation();
    }
  }) : /*#__PURE__*/React.createElement(LTTooltip, {
    direction: LTTooltip.Direction.RIGHT,
    text: tooltip
  }, icon)), /*#__PURE__*/React.createElement(LTTooltip, {
    customTriggerStyle: {
      overflow: "hidden"
    },
    text: title || ""
  }, /*#__PURE__*/React.createElement(Title, __assign({
    id: "lt-card-name",
    onClick: onClick,
    style: {
      overflow: "hidden",
      display: "inline-block",
      marginRight: "8px"
    },
    tabIndex: 0
  }, props), /*#__PURE__*/React.createElement(LTText, {
    style: {
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      display: "block"
    },
    variant: LTText.TextVariant.SUBHEADER_BOLD
  }, title || ""))));
};
var ConditionalLinkWrapper = function ConditionalLinkWrapper(_a) {
  var children = _a.children,
    isLink = _a.isLink,
    _b = _a.onClick,
    onClick = _b === void 0 ? function () {} : _b;
  return isLink ? /*#__PURE__*/React.createElement(ActionLink, {
    onClick: onClick,
    onKeyPress: function onKeyPress(e) {
      return isEnterOrSpacePressed(e) && onClick();
    },
    role: "button",
    style: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      width: "100%",
      overflow: "hidden"
    },
    tabIndex: 0
  }, children) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
var SubInfo = function SubInfo(_a) {
  var _b = _a.content,
    content = _b === void 0 ? "" : _b,
    icon = _a.icon,
    _c = _a.isLink,
    isLink = _c === void 0 ? false : _c,
    _d = _a.onClick,
    onClick = _d === void 0 ? function () {} : _d,
    showEllipsis = _a.showEllipsis,
    _e = _a.tooltip,
    tooltip = _e === void 0 ? "" : _e;
  return /*#__PURE__*/React.createElement("div", {
    style: showEllipsis ? {
      maxWidth: "50%",
      overflow: "hidden"
    } : {}
  }, /*#__PURE__*/React.createElement(LTTooltip, {
    text: tooltip,
    key: tooltip
  }, /*#__PURE__*/React.createElement(Unit, null, icon, /*#__PURE__*/React.createElement(ConditionalLinkWrapper, {
    onClick: onClick,
    isLink: isLink
  }, /*#__PURE__*/React.createElement(LTText, {
    color: "fg.muted",
    style: {
      display: "block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    variant: LTText.TextVariant.SMALL_REGULAR
  }, content)))));
};
var LTAutomationCard = function LTAutomationCard(_a) {
  var _b = _a.heading,
    heading = _b === void 0 ? {} : _b,
    secondaryElement = _a.secondaryElement,
    _c = _a.subInfo,
    subInfo = _c === void 0 ? [] : _c;
  return /*#__PURE__*/React.createElement(Card, {
    id: "lt-card"
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Heading, __assign({}, heading)), /*#__PURE__*/React.createElement(OtherInfo, null, subInfo.map(function (info, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, info.type === "tags" ? /*#__PURE__*/React.createElement(LTTagGroup, __assign({}, info)) : /*#__PURE__*/React.createElement(SubInfo, __assign({}, info)), index < subInfo.length - 1 && !info.noDot && /*#__PURE__*/React.createElement(Dot, null));
  }))), /*#__PURE__*/React.createElement(SecondaryElements, {
    id: "lt-card-secondary-action"
  }, secondaryElement));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

export { LTAutomationCard as default };
